import { PLATFORM } from 'aurelia-pal';

export const configure = (frameworkConfig) => {
  if (frameworkConfig.globalResources) {
    frameworkConfig.globalResources(
      PLATFORM.moduleName('./customAttributes/oacClass.customAttribute'),
      PLATFORM.moduleName('./customAttributes/oacClickOutside.customAttribute'),
      PLATFORM.moduleName('./valueConverters/oacListFilter.valueConverter'),
      PLATFORM.moduleName('./valueConverters/oacListMap.valueConverter'),
    );
  }
};
